import { loadStripe, Stripe } from '@stripe/stripe-js';

/**
 * Stripe Security & PCI-DSS Compliance Utility
 * Ensures Stripe iFrame checkout complies with PCI-DSS SAQ A standards.
 */

/**
 * Validates Stripe Publishable Key presence
 */
export function validateStripeKey(): string {
  const pk = process.env.REACT_APP_STRIPE_PK;
  if (!pk || pk.trim() === '') {
    console.warn('Stripe Publishable Key (REACT_APP_STRIPE_PK) is missing or unconfigured.');
  }
  return pk || '';
}

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Singleton getter for loadStripe.
 * Ensures loadStripe is called at most ONCE across the entire application lifecycle.
 */
export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    const pk = validateStripeKey();
    stripePromise = loadStripe(pk);
  }
  return stripePromise;
}

